export interface QuickItem {
  num: string;
  label: string;
  href: string;
  tag: string;
  desc: string;
}

export const quickIndex: QuickItem[] = [
  {
    num: '01',
    label: '同类盘点',
    href: '#pandian',
    tag: '主榜单',
    desc: '按话题形态归类的相似现象样本，一条摘要看懂传播套路。',
  },
  {
    num: '02',
    label: '事件脉络',
    href: '#mailuo',
    tag: '时间轴',
    desc: '一个话题从发酵到平息的典型节奏，吃瓜不再漏剧情。',
  },
  {
    num: '03',
    label: '横向对比',
    href: '#duibi',
    tag: '多维表',
    desc: '把同类案例放进同一张表，起因、热度、走向一眼看清。',
  },
  {
    num: '04',
    label: '舆论现场',
    href: '#shengyin',
    tag: '切片',
    desc: '站队、玩梗、质疑几种典型声量长什么样，拆开给你看。',
  },
  {
    num: '05',
    label: '概念速查',
    href: '#cidian',
    tag: '词条卡',
    desc: '热搜舆论里的黑话速查手册，看到不再一头雾水。',
  },
  {
    num: '06',
    label: '常见疑问',
    href: '#faq',
    tag: 'FAQ',
    desc: '被反复问到的细节一次性讲清，省去到处翻评论的时间。',
  },
];

export interface TimelineItem {
  phase: string;
  label: string;
  tone: string;
  desc: string;
}

export const timeline: TimelineItem[] = [
  {
    phase: 'T0 · 冒头',
    label: '线索冒头',
    tone: '静',
    desc: '一条帖子、一个截图或一段录屏率先扩散，讨论停留在小圈子，关键词开始进入搜索联想。',
  },
  {
    phase: 'T1 · 爆发',
    label: '热度爆发',
    tone: '涨',
    desc: '多个平台同时搬运转发，话题冲上热搜前列，标题党与解读稿集中出现，声量到达峰值。',
  },
  {
    phase: 'T2 · 拉锯',
    label: '站队拉锯',
    tone: '热',
    desc: '信息出现版本分歧，支持与质疑两派互相引用截图，玩梗二创与认真科普并行扩散。',
  },
  {
    phase: 'T3 · 反转',
    label: '反转 / 补充',
    tone: '变',
    desc: '后续信源陆续补充，早期说法被修正或推翻，话题进入第二轮讨论，热度出现二次小峰。',
  },
  {
    phase: 'T4 · 沉淀',
    label: '沉淀平息',
    tone: '落',
    desc: '新瓜顶上热搜，旧话题转入回顾与盘点，留下的多是一句梗和几份整理的吃瓜合集。',
  },
];

export interface RoundupItem {
  rank: string;
  heat: number;
  title: string;
  tags: string[];
  summary: string;
}

export const roundup: RoundupItem[] = [
  {
    rank: '01',
    heat: 98,
    title: '话题冲榜型：关键词一夜爬上前排',
    tags: ['热搜', '冲榜'],
    summary: '由一个带争议的命名词引发，搜索量与讨论量在数小时内同步飙升，网友边搜边自发写"科普帖"，是最典型的入口型现象。',
  },
  {
    rank: '02',
    heat: 93,
    title: '盘点合集型：一条长帖撑起吃瓜主场',
    tags: ['盘点', '合集'],
    summary: '核心传播物是整理好的时间线与截图合集，读者通过转发合集"补课"。内容组织方式决定了它能被反复阅读、二次传播。',
  },
  {
    rank: '03',
    heat: 88,
    title: '站队舆论型：正反两派各自输出',
    tags: ['舆论', '站队'],
    summary: '观点分歧被刻意放大成对立话题，评论区形成稳定两派，各自引用不同信源，节奏上呈现出明显的"拉锯感"。',
  },
  {
    rank: '04',
    heat: 84,
    title: '玩梗解构型：严肃话题被拆成段子',
    tags: ['玩梗', '二创'],
    summary: '大众情绪不直接争论对错，而是通过表情包与段子解构事件，反而让话题以更轻的姿态持续占据信息流。',
  },
  {
    rank: '05',
    heat: 76,
    title: '反转补充型：真相被一步步挤出来',
    tags: ['反转', '跟进'],
    summary: '早期结论并不完整，随着更多当事人与信源发声，话题经历"先热后冷再回热"的三段式，留下清晰的复盘价值。',
  },
  {
    rank: '06',
    heat: 71,
    title: '后热回顾型：热度退去后的二次消费',
    tags: ['回顾', '复盘'],
    summary: '当新瓜占据头条，旧话题转为定期"考古"素材，被做成年度盘点或同类对比，进入长尾浏览与检索阶段。',
  },
];

export interface CompareRow {
  axis: string;
  a: string;
  b: string;
  c: string;
  winner: number;
}

export const compareHeader = ['对比维度', '案例甲', '案例乙', '案例丙'];

export const compareRows: CompareRow[] = [
  {
    axis: '起因触发',
    a: '单一争议词',
    b: '多信源联动',
    c: '事件链累积',
    winner: 1,
  },
  {
    axis: '传播主力',
    a: '搜索 + 热搜',
    b: '转发 + 评论区',
    c: '二创 + 短视频',
    winner: 2,
  },
  {
    axis: '热度峰值',
    a: '爆发快',
    b: '峰值高',
    c: '持续时间长',
    winner: 2,
  },
  {
    axis: '舆论走向',
    a: '站队为主',
    b: '反转为辅',
    c: '玩梗消化',
    winner: 0,
  },
  {
    axis: '沉淀形式',
    a: '盘点合集',
    b: '观点长文',
    c: '梗文化遗留',
    winner: 0,
  },
];

export const opinionChips = ['玩梗党', '认真分析派', '吃瓜路转粉', '质疑求真派', '考据党', '纯围观'];

export interface OpinionQuote {
  side: string;
  icon: string;
  text: string;
}

export const opinionQuotes: OpinionQuote[] = [
  {
    side: '认真分析派',
    icon: 'ri-search-eye-line',
    text: '比起急着表态，先把时间线拉出来，谁的叙述在前、谁在后，版本一对比问题就清楚了。',
  },
  {
    side: '玩梗解构派',
    icon: 'ri-emotion-laugh-line',
    text: '严肃归严肃，梗也得有。热点被拆成段子之后，反而更容易让新来的朋友快速get到发生了什么。',
  },
  {
    side: '质疑求真派',
    icon: 'ri-question-mark',
    text: '转发的截图未必全，多搜几版看看，别让"看起来很像"代替了"确实是"。信源要交叉验证。',
  },
];

export interface GlossaryTerm {
  term: string;
  type: string;
  desc: string;
}

export const glossary: GlossaryTerm[] = [
  {
    term: '热搜冲榜',
    type: '传播机制',
    desc: '话题搜索量与讨论量在短时间集中上涨，推动关键词进入平台热搜前列，带来第一波大规模曝光。',
  },
  {
    term: '吃瓜群众',
    type: '人群',
    desc: '不直接站队、以围观和跟随信息流为主的普通网友，是话题声量的基本盘，也是二次传播的主要来源。',
  },
  {
    term: '站队舆论',
    type: '舆论形态',
    desc: '观点在评论区集中为互相对立的两极，形成稳定"对垒"，常伴随互晒截图与引用信源的拉锯。',
  },
  {
    term: '反转打脸',
    type: '剧情节点',
    desc: '早期说法被后续信源推翻或修正，是热点话题最常见的"剧情高光点"，也最能刺激二次讨论。',
  },
  {
    term: '信息茧房',
    type: '传播学',
    desc: '算法只推荐你常看的观点，导致同一热点在不同人眼里呈现出完全不同的"版本"，加剧认知分歧。',
  },
  {
    term: '舆情回落',
    type: '生命周期',
    desc: '新热点接管注意力后，旧话题讨论量自然下降，转入回顾盘点与检索长尾，是热点曲线的自然收尾。',
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faq: FaqItem[] = [
  {
    q: '为什么同一个话题，大家看到的"剧情"完全不一样？',
    a: '核心原因是信息获取路径不同。算法按你的历史偏好推送内容，再加上版本传播有先后，很多人其实只看到了完整链条里的一段，自然得出不同结论。跨平台、跨观点多搜几版，能有效减少"只看到一半"的偏差。',
  },
  {
    q: '热度是怎么涨起来的？主要靠哪些平台？',
    a: '通常是"搜索关键词"与"平台热搜"双轮驱动：先有争议性命名词把讨论聚拢，再由多个平台的转发、评论区与二创同时放大。不同类型的现象，主力阵地会有差别，有的靠长帖复盘，有的靠短视频。',
  },
  {
    q: '玩梗和认真讨论，哪种更有助于吃明白这个瓜？',
    a: '两者作用不同。梗适合快速"入门"，帮新人低成本记住核心冲突；但真要吃明白前因后果、避免被带偏，还是要看时间线整理和多方信源。先轻松入门，再认真补课，是比较舒服的组合。',
  },
  {
    q: '转发的截图和消息，能完全相信吗？',
    a: '不建议。截图很容易脱离上下文被选择性截取，转发过程中也可能二次加工。判断一条信息是否可信，看三点：是否标注来源、是否能找到原始出处、是否有多个独立信源相互印证。没有来源的"实锤"，先保持观望。',
  },
];

export const navLinks = [
  { label: '速览索引', href: '#suolan' },
  { label: '同类盘点', href: '#pandian' },
  { label: '事件脉络', href: '#mailuo' },
  { label: '横向对比', href: '#duibi' },
  { label: '舆论现场', href: '#shengyin' },
  { label: '概念速查', href: '#cidian' },
  { label: '常见疑问', href: '#faq' },
];